function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#change_size_svg__seeds-svgs_grip-lines-vertical-outline"
});

var SvgChangeSize = function SvgChangeSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "change_size_svg__Icon-svg",
    viewBox: "0 0 18 18",
    "data-qa-icon-svg": "grip-lines-vertical-outline-svg"
  }, props), _ref);
};

export default SvgChangeSize;